import React, { useState } from "react";
import { Row, Col, Image, Badge, Container, Modal } from "react-bootstrap";
import {
  User, Cake, Ruler, Eye, Palette, Languages, Globe, Star, Shirt, UserCheck, FileText,Share2
} from "lucide-react";
import Swal from "sweetalert2";


import "./AuditionDetailHeader.css";

const AuditionDetailHeader = ({ audition }) => {

  const [showDesc, setShowDesc] = useState(false);
  const [showReq, setShowReq] = useState(false);

  if (!audition) return null;
   const handleShare = async () => {
    const shareTitle = `${audition.projectName} - Audition Details`;
    const shareText = `Check out the audition requirements for ${audition.projectName} (Role: ${audition.roleName}) on BookMyAudition!`;
    const shareUrl = window.location.href;
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl,
        });
      } catch (err) {
        console.log('Share canceled or failed', err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(shareUrl);
        Swal.fire({
          icon: 'success',
          title: 'Link Copied!',
          text: 'Audition details link copied to clipboard.',
          width: '380px',
          background: '#131824',
          color: '#ffffff',
          confirmButtonColor: '#dc3545',
          customClass: {
            title: 'text-white fw-bold fs-5 mb-2',
            htmlContainer: 'text-muted mb-3 fs-6',
            confirmButton: 'btn btn-danger px-4 py-2 fw-bold'
          },
          buttonsStyling: false
        });
      } catch (err) {
        console.error('Failed to copy link', err);
      }
    }
  };
  const formatCamelCase = (text) => {
  if (!text) return "";

  return text
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(
      /\w\S*/g,
      (word) =>
        word.charAt(0).toUpperCase() +
        word.slice(1).toLowerCase()
    );
};


  // ✅ Array for the horizontal bar with icons
  const keyRequirements = [
    { label: "Age", value: formatCamelCase(audition.age), icon: <Cake size={24}/> },
    { label: "Gender", value: formatCamelCase(audition.gender), icon: <UserCheck size={24}/> },
    { label: "Language", value: formatCamelCase(audition.preferredLanguages), icon: <Languages size={24}/> },
    { label: "Nationality", value: formatCamelCase(audition.nationality), icon: <Globe size={24}/> },
    { label: "Skin", value: formatCamelCase(audition.skinTone), icon: <Palette size={24}/> },
  ].filter(req => req.value && req.value.trim() !== "");

  // Array for the full requirements modal popup (with icons)
  const allRequirements = [
    { label: "Talent", value: formatCamelCase(audition.talent), icon: <User size={18}/> },
    { label: "Age", value: formatCamelCase(audition.age), icon: <Cake size={18}/> },
    { label: "Gender", value: formatCamelCase(audition.gender), icon: <UserCheck size={18}/> },
    { label: "Height", value: formatCamelCase(audition.height), icon: <Ruler size={18}/> },
    { label: "Body Type", value: formatCamelCase(audition.bodyType), icon: <User size={18}/> },
    { label: "Skin Tone", value: formatCamelCase(audition.skinTone), icon: <Palette size={18}/> },
    { label: "Eye Color", value: formatCamelCase(audition.eyeColor), icon: <Eye size={18}/> },
    { label: "Hair Color", value: formatCamelCase(audition.hairColor), icon: <Palette size={18}/> },
    { label: "Hair Type", value: formatCamelCase(audition.hairType), icon: <User size={18}/> },
    { label: "Language", value: formatCamelCase(audition.preferredLanguages), icon: <Languages size={18}/> },
    { label: "Dialect", value: formatCamelCase(audition.dialect), icon: <Languages size={18}/> },
    { label: "Nationality", value: formatCamelCase(audition.nationality), icon: <Globe size={18}/> },
    { label: "Experience", value: formatCamelCase(audition.experienceLevel), icon: <Star size={18}/> },
    { label: "Waist Size", value: formatCamelCase(audition.waistSize), icon: <Shirt size={18}/> },
    { label: "Chest Size", value: formatCamelCase(audition.chestSize), icon: <Shirt size={18}/> },
    { label: "Special Category", value: formatCamelCase(audition.specialCategory), icon: <Star size={18}/> }
  ];

  const filteredAllRequirements = allRequirements.filter(
    req => req.value && req.value.trim() !== ""
  );
  // const formatCamelCase = (text) => {

  //   if (!text) return "";

  //   return text
  //     .replace(/([A-Z])/g, " $1")
  //     .trim()
  //     .replace(
  //       /\w\S*/g,
  //       (word) =>
  //         word.charAt(0).toUpperCase() +
  //         word.slice(1).toLowerCase()
  //     );
  // };

  return (
    <section className="audition-header">
      {/* <Container fluid="lg"> */}
      <Container fluid>
        <Row className="align-items-start header-row">
          {/* --- POSTER --- */}
          <Col xs={4} lg={3} className="poster-column">
            <div className="poster-image">
              <Image
                src={audition.projectImageUrl}
                alt={audition.projectName}
                className="poster-image-content"
              />
            </div>
          </Col>

          {/* --- PROJECT INFO --- */}
                    {/* --- PROJECT INFO --- */}
          <Col xs={8} lg={5} className="info-column">
            <div className="d-flex align-items-center gap-3 mb-2 flex-wrap">
              <h2 className="project-title mb-0">
                {audition.projectName}
              </h2>
              {/* ✅ Premium circular share button with hover effects */}
              <button 
                onClick={handleShare}
                className="btn text-danger p-1 d-flex align-items-center justify-content-center"
                title="Share Audition"
                style={{ 
                  background: 'rgba(220, 53, 69, 0.1)', 
                  border: '1px solid rgba(220, 53, 69, 0.3)',
                  borderRadius: '50%',
                  width: '36px',
                  height: '36px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#dc3545';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(220, 53, 69, 0.1)';
                  e.currentTarget.style.color = '#dc3545';
                }}
              >
                <Share2 size={16} />
              </button>
            </div>
            <h5 className="role-title">
              ROLE: {audition.roleName}
            </h5>
            <div className="badge-container">
              <span className="badge-dark">{formatCamelCase(audition.projectType)}</span>
              {audition.displayAuditionTypes?.map((type, idx) => (
                <span key={idx} className="badge-dark">
                  {type}
                </span>
              ))}
            </div>
            {/* ✅ Description with "View More" Link */}
            <div className="section-title-wrapper">
              <h4 className="requirements-title mb-0">Description</h4>
            </div>
            <div className="description-desktop">
              <span dangerouslySetInnerHTML={{ __html: audition.fullDescription }}/>
            </div>
            <span className="view-more-link" onClick={() => setShowDesc(true)}>
              View More
            </span>

          </Col>
          <Col xs={12} lg={4} className="info-column">
            {/* ✅ Horizontal Bar with Icons */}
            <div className="section-title-wrapper mt-4">
              <h4 className="requirements-title mb-0">Talent Requirements</h4>
            </div>
            <div className="requirements-bar">
              {keyRequirements.map((req, index) => (
                <div key={index} className="requirement-item">
                  <div className="requirement-icon d-none d-lg-flex">{req.icon}</div>
                  <div>
                    <span className="requirement-label">{req.label}</span>
                    <span className="requirement-value">{req.value}</span>
                  </div>
                </div>
              ))}
            </div>
            <span className="view-more-link" onClick={() => setShowReq(true)}>View All</span>
          </Col>
        </Row>
      </Container>

      {/* ✅ DARK DESCRIPTION MODAL */}
      {/* ✅ DARK DESCRIPTION MODAL - CORRECTED */}
        <Modal 
          show={showDesc} 
          onHide={() => setShowDesc(false)} 
          centered 
          contentClassName="modal-dark-content"
        >
          <Modal.Header closeButton closeVariant="white" className="modal-dark-header">
            <Modal.Title className="d-flex align-items-center gap-2 description-modal-title">
              <FileText size={20}/> Description
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-4 description-modal-body" >
            <div dangerouslySetInnerHTML={{ __html: audition.fullDescription }}/>
          </Modal.Body>
        </Modal>

        {/* ✅ DARK REQUIREMENTS MODAL - CORRECTED */}
        <Modal 
          show={showReq} 
          onHide={() => setShowReq(false)} 
          centered 
          contentClassName="modal-dark-content"
        >
          <Modal.Header closeButton closeVariant="white" className="modal-dark-header">
            <Modal.Title className="d-flex align-items-center gap-2">
              <UserCheck size={20}/> Talent Requirements
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-4 description-modal-body">
            <div className="requirements-grid">
              {filteredAllRequirements.map((req, index) => (
                <div key={index} className="req-card">
                  <div className="req-icon">{req.icon}</div>
                  <div>
                    <span className="req-label">{req.label}</span>
                    <span className="req-value">{formatCamelCase(req.value)}</span>
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
    </section>
  );
};

export default AuditionDetailHeader;